import $ from "jquery";

window.PIXI = require('phaser/build/custom/pixi');
window.p2 = require('phaser/build/custom/p2');
window.Phaser = require('phaser/build/custom/phaser-split');

class Main {
    constructor(el) {
        const $el = $(el);
        const images = [];

        $el.find('li').each((i, e) => {
            images.push($(e).html());
        });

        this.sizes = this.setSize($el);
        const config = {
            width: this.sizes[0],
            height: this.sizes[1],
            renderer: Phaser.AUTO,
            parent: el,
            state: {
                preload,
                create,
                update
            },
            transparent: true,
        };

        this.game = new Phaser.Game(config);

        window.addEventListener('resize', () => {
            const sizes = this.setSize($el);
            this.game.scale.setGameSize(sizes[0], sizes[1]);
            this.game.scale.refresh();
        });

        function preload() {
            for (let i = 0; i < images.length; i++) {
                this.game.load.image('image' + i, images[i]);
            }
        }

        function create() {
            const {game} = this;
            this.sprites = [];
            this.groups = [];

            //	Enable p2 physics
            this.game.physics.startSystem(Phaser.Physics.P2JS);
            this.game.physics.p2.gravity.y = 0;

            //  Make things a bit more bouncey
            this.game.physics.p2.defaultRestitution = 0.8;

            for (let i = 0; i < images.length; i++) {
                this.groups[i] = this.add.group();
                this.sprites[i] = this.game.add.sprite(random(0, game.world.width), random(0, game.world.height), 'image' + i);
                this.groups[i].add(this.sprites[i]);
                
                if (game.world.width <= 500) {
                    this.sprites[i].scale.setTo(.5, .5);
                }
            }
            this.game.physics.p2.enable(this.sprites, false);
            this.game.physics.p2.updateBoundsCollisionGroup();

            for (let i = 0; i < images.length; i++) {
                this.sprites[i].body.setZeroDamping();
                this.sprites[i].body.fixedRotation = true;
                this.sprites[i].body.collides([]);
            }

            this.mouseBody = new p2.Body();
            this.game.physics.p2.world.addBody(this.mouseBody);

            this.bodiesItems = [];

            for (let i = 0; i < images.length; i++) {
                this.bodiesItems.push(this.sprites[i]);
            }

            this.game.input.onDown.add(click, this);
            this.game.input.onUp.add(release, this);
            this.game.input.addMoveCallback(move, this);
        }

        function click(pointer) {
            var bodies = this.game.physics.p2.hitTest(pointer.position, this.bodiesItems);

            // p2 uses different coordinate system, so convert the pointer position to p2's coordinate system
            var physicsPos = [this.game.physics.p2.pxmi(pointer.position.x), this.game.physics.p2.pxmi(pointer.position.y)];

            if (bodies.length) {
                var clickedBody = bodies[0];
                this.game.world.bringToTop(clickedBody.parent.sprite.parent);

                var localPointInBody = [0, 0];
                // this function takes physicsPos and coverts it to the body's local coordinate system
                clickedBody.toLocalFrame(localPointInBody, physicsPos);
                // use a revoluteContraint to attach mouseBody to the clicked body
                this.mouseConstraint = this.game.physics.p2.createRevoluteConstraint(this.mouseBody, [0, 0], clickedBody, [this.game.physics.p2.mpxi(localPointInBody[0]), this.game.physics.p2.mpxi(localPointInBody[1])]);
            }
        }

        function release() {
            this.game.physics.p2.removeConstraint(this.mouseConstraint);
        }

        function move(pointer) {
            this.mouseBody.position[0] = this.game.physics.p2.pxmi(pointer.position.x);
            this.mouseBody.position[1] = this.game.physics.p2.pxmi(pointer.position.y);

            let bodies = this.game.physics.p2.hitTest(pointer.position, this.bodiesItems);

            if (bodies.length) {
                this.game.canvas.style.cursor = "move";
            } else {
                this.game.canvas.style.cursor = "default";
            }
        }

        function update() {
        }

        function random(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }
    }

    setSize($el) {
        let $canvas = $el.find('canvas');
        $canvas.hide();

        let height = $el.height();

        if ($el.width() === window.innerWidth) {
            if ($el.width() < 500) {
                height = $el.width();
            } else {
                height = 400;
            }
        }

        if (height === 0) {
            height = 400;
        }

        setTimeout(() => {
            $canvas.show();
        }, 0);

        return [$el.width(), height];
    }
}

export default Main;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/drag.js